<template>
    <div>
    <div v-if="resources && resources.length === 0" class="text-center">
        <p>No resources for this week.</p>
    </div>
    <table class="course-table resources-table" v-if="resources">
        <thead>
        </thead>
        <tbody>
            <tr v-for="(resource, index) in resources" 
            v-bind:class="weekPosition(resource.week)">
                <td v-if="localStorage.roles.indexOf('Student')===-1 && localStorage.roles.indexOf('CampusStudent') === -1"><i @click.prevent="deleteResource(resource.id, index)" class="fa fa-remove remove-file"></i></td>
                <td>Week {{resource.week}}</td>
                <td>{{resource.description}}</td>   
                <td>
                    <a v-if="resource.url.includes('amazonaws')"  @click.prevent="downloadFile(resource.url, resource.id)">{{resource.name}}</a>
                    <a v-else :href="resource.url" target="_blank">{{resource.name}}</a>
                </td>
            </tr>
        </tbody>
    </table>
    </div>
</template>

<script>
    
import files from '../../services/files';    
import toastr from 'toastr';

export default {
    props: ['instanceId', 'currentWeek'],
    data() {
        return {
            week:null,
            resources:null
        }
    },
    mounted() {
        var self = this;
        this.getFiles();
        this.week = this.currentWeek;

        this.$bus.$on('resource_added', function() {
            self.getFiles();
        });
    },
    watch: {
        currentWeek: function(week) {
            this.getFiles();
            this.week = week;
        }
    },
    methods: {
        downloadFile(file, id) {
           this.$bus.$emit('download', file, 'resource', id);
        },
        deleteResource(id, index) {
            var self = this;
            files.delete(this, id).then(function(response) {
                if (response.data.success === true) {
                    self.resources.splice(index, 1);
                } else {
                    toastr.error('Error deleting resource');
                }
            });
        },
        weekPosition(week) {
            var currentWeek = this.week;
            if (week === currentWeek) return 'this-week';
            if (week < currentWeek) return 'past';
            if (week > currentWeek) return 'future';
        },
        getFiles() {      

            var self = this;
            var query = {
                instanceId: self.instanceId,  
                week: self.currentWeek
            }   
  
            files.get(this, query).then(function(response) {
                
                self.resources = response.data.filter((r)=>{
                    return r.instanceId === self.instanceId && r.week == self.week;
                });
                var data = {
                    type: 'resources',
                    data: response.data
                }
                self.$store.dispatch('populate', data);
            });
        },

    },
    computed: {
     
    }
}

</script>

<style lang="scss">
    .resources-table td a {
        cursor:pointer!important;
    }
</style>




// WEBPACK FOOTER //
// Resources.vue?4228b0ec